import type { BreadcrumbItem } from '../types';

export const getBreadcrumbItems = (
  stressAssessmentId: string,
  stressAssessmentTitle?: string,
  userName?: string
): BreadcrumbItem[] => {
  return [
    { label: 'ストレスチェック', href: '/stress-assessments' },
    {
      label: stressAssessmentTitle || 'レポート',
      href: `/stress-assessments/${stressAssessmentId}/reports`,
    },
    { label: userName ? `${userName}さんの調査結果` : '調査結果' },
  ];
};
